const normaliseZipcode = (value:any) => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if(value.length >5){
      return onlyNums.slice(0, 5)
  }
  else return onlyNums
}

export default normaliseZipcode